module.exports = __webpack_public_path__ + "static/media/002-phone-call.8b2f97f7.svg";